<template>
    <kt-modal
        :visible="true"
        :title="recordTitle"
        size="modal-lg"
        @dismiss="onClose()"
    >
        <template #body>
            <expense-form v-model="record" :pm-only="props.pmOnly"></expense-form>
        </template>
    
        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onClose()" class="btn btn-sm btn-outline-secondary form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">Save</button>
                </div>
            </div>
        </template>
        
    </kt-modal>
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import { ExpenseModel } from "@/models/ExpenseModel";
import ApiService from "@/services/ApiService";
import Helper from "@/services/Helper";
import Alert from "@/services/Alert";
import KtModal from "@/components/UI/KtModal.vue";
import ExpenseForm from "@/components/Expenses/ExpenseForm.vue";

const props = defineProps({
    recordId: {
        type: String,
        required: true
    },
    requestId: {
        type: [Number, String],
        default: null
    },
    clientId: {
        type: [Number, String],
        default: null
    },
    techId: {
        type: [Number, String],
        default: null
    },
    pmOnly: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(['close']);

const recordTitle = ref("Expense Entry");

const newRecord = () => {
    const expense = new ExpenseModel();
    // Pre-populate with requestId if provided
    if (props.requestId) {
        expense.RequestId = Number(props.requestId);
    }
    // Pre-populate with clientId if provided
    if (props.clientId) {
        expense.CustomerNumber = Number(props.clientId);
    }
    // Pre-populate with techId if provided
    if (props.techId) {
        expense.AssignedTo = Number(props.techId);
    }
    // Set default expense date to today
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    expense.ExpenseDate = `${year}-${month}-${day}`;
    return expense;
};

const record = ref<ExpenseModel>(newRecord());

const saveRecord = async () => {
    let data = Helper.prep(record.value);
    console.debug("save", data);
    data = await ApiService.saveExpense(data);
    // Close modal and refresh parent list
    emit('close');
};

const deleteRecord = async () => {
    Alert.notify("Deletion has been disabled.");
};

const onClose = () => {
    emit('close');
};

const loadRecord = async (val: string) => {
    switch (val) {
        case "new":
            let tmp = newRecord();
            recordTitle.value = "New Expense Entry";
            record.value = tmp;
            break;

        default:
            let rec = await ApiService.loadExpense(val);
            recordTitle.value = "Edit Expense Entry";
            record.value = rec;
            break;
    }
};

// Load record when component mounts or recordId changes
watch(() => props.recordId, (newId) => {
    if (newId) {
        loadRecord(newId);
    }
}, { immediate: true });
</script>
